import startContent from "./start-content.json";
import FloatingBackButton from "../components/FloatingBackButton";
import ParallaxPage from "../components/ParallaxPage";
import React from "react";
import webContent from "./web-content.json";
import {Spacer} from "../components/Spacer";
import {ParagraphsComponent} from "../components/ParagraphsComponent";

export const Web = () => {
    return (
        <div>
            <FloatingBackButton/>
            <ParallaxPage
                imageUrl={startContent.web.imageUrl}
                content={
                    <div>
                        <h1>{webContent.title}</h1>
                        <h2>{webContent.subtitle}</h2>
                        <Spacer height={100}/>
                        <ParagraphsComponent paragraphs={webContent.paragraphs} />
                    </div>
                }
            />
        </div>
    );
};